import { ToastType } from '@components/toast';
import { QuoteCloneFromRelatedPolicyPostRequestBody, QuoteCloneFromRelatedPolicyPostResponse } from '@lio/api-types';
import { PolicyMonolineInsuranceLineKeys } from '@services/policy/useGetAvailablePolicyMonolineInsuranceLines';
import { quoteSearchQueryKeys } from '@services/quotes/useQuoteSearch';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { useSnackbar } from 'notistack';

export const useCreateLinkedQuoteFromPolicy = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutationFn = async (requestBody: QuoteCloneFromRelatedPolicyPostRequestBody) =>
    client
      .post(`related-policy-quote`, {
        json: requestBody,
      })
      .json<QuoteCloneFromRelatedPolicyPostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data, { policyId }) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          // quote metadata
          query.queryKey.includes('quoteMetadata') ||
          // quote search
          query.queryKey.includes(quoteSearchQueryKeys.search[0]) ||
          // monline items for this policu
          (query.queryKey.includes(PolicyMonolineInsuranceLineKeys.search[0]) && query.queryKey.includes(policyId)),
      });
      // the currently policy
      queryClient.invalidateQueries({ queryKey: ['policy', { policyId }] });
      return data;
    },
    onError: (_: any) => {
      enqueueSnackbar('An error occurred', {
        variant: ToastType.Error,
        preventDuplicate: true,
        persist: true,
      });
    },
  });
  return { ...result, createLinkedQuoteFromPolicy: result.mutateAsync };
};
